// extracted by mini-css-extract-plugin
module.exports = {"sideMenu":"SideMenu_sideMenu__1ewG7"};